export const trackGTMEvent = (gtmObj) => {
  window.dataLayer && window.dataLayer.push(gtmObj);
};
